import { forwardRef, useImperativeHandle, useLayoutEffect, useRef, type TextareaHTMLAttributes } from "react";

export const ExpandingTextarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
  function ExpandingTextarea({ className = "", value, rows = 6, ...props }, forwardedRef) {
    const ref = useRef<HTMLTextAreaElement>(null);
    useImperativeHandle(forwardedRef, () => ref.current!, []);
    useLayoutEffect(() => {
      const element = ref.current;
      if (!element) return;
      const resize = () => {
        element.style.height = "auto";
        const border = element.offsetHeight - element.clientHeight;
        element.style.height = `${element.scrollHeight + border}px`;
      };
      resize();
      let width = element.clientWidth;
      let frame = 0;
      const observer = new ResizeObserver(() => {
        if (element.clientWidth !== width) {
          width = element.clientWidth;
          cancelAnimationFrame(frame);
          frame = requestAnimationFrame(resize);
        }
      });
      observer.observe(element);
      return () => { observer.disconnect(); cancelAnimationFrame(frame); };
    }, [value]);
    return <textarea {...props} ref={ref} rows={rows} value={value} className={`expanding-textarea ${className}`} />;
  },
);
